import React from "react"
import Rails from "@rails/ujs"
import { FormsyHiddenInput } from "shared/inputs"

const AuthenticityTokenField = () => (
  <FormsyHiddenInput name="authenticity_token" value={Rails.csrfToken()} />
)

export default AuthenticityTokenField
